import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "slick-carousel/slick/slick";
import $ from "jquery";

window.jQuery = window.$ = $

import initStylebook from "/lib/stylebook";
import initGreenSock from "/lib/greensock";
import initHeadroom from "/lib/headroom";
import initMobileNav from "/lib/mobile-nav";
import initCookies from "/lib/cookies";
import initMagnificPopup from "/lib/magnificPopup";
import initAccordion from "/lib/accordion";
import initTabs from "/lib/tabs";
import initImageGallery from "/lib/image-gallery";
import initTestimonials from "/lib/testimonials";
import initA11yFunctions from "/lib/accessibility";
import initSlider from "/lib/slider";
import initThemeToggle from "/lib/themeToggle";
import animatedBlob from "/lib/animatedBlob";
import initGreenHoverAnimation from "/lib/greenHoverAnimation";
import initHeroTypeAnimation from "/lib/heroAnimations";
import initCountUp from "/lib/countUp";
import initChart from "/lib/chart";
import initCustomNavbar from "/lib/customNavbar";
import initFooterForm from "/lib/footer";
import initLoginMap from "/lib/loginMap";
import initSearch from "/lib/search";
import handleNewsletterSignUp from "/lib/newsletter-form";
import initDomainChecker from "./lib/domain-checker";
import createInPageNav from './lib/inPageNav'

initMagnificPopup();
initCustomNavbar();
initFooterForm();
initStylebook();
initHeadroom();
initMobileNav();
initCookies();
initAccordion();
initTabs();
initImageGallery();
initTestimonials();
initA11yFunctions();
initSlider();
initThemeToggle();
animatedBlob();
initGreenHoverAnimation();
initHeroTypeAnimation();
initCountUp();
initChart();
initLoginMap();
initSearch();
handleNewsletterSignUp();
initDomainChecker();
createInPageNav('#post-content', '#in-page-nav')
initGreenSock();